import { ErrorPage } from '~/components/pages/ErrorPage';
import { RootTemplate } from '~/components/templates/RootTemplate';

export const ErrorRoute: React.FC = () => (
  <RootTemplate>
    <ErrorPage />
  </RootTemplate>
);
